import cookieStore from 'js-cookie';

export const set = (key, value, options) => // eslint-disable-line no-confusing-arrow
  process.browser ? cookieStore.set(key, value, { ...options, ...{ sameSite: 'strict', secure: true } }) : null;
export const get = key => // eslint-disable-line no-confusing-arrow
  process.browser ? cookieStore.get(key) : null;
export const remove = key => // eslint-disable-line no-confusing-arrow
  process.browser ? cookieStore.remove(key, { path: '/' }) : null;
